import React from "react";
import "./Produk3.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import Lilyimages from "../../../Media/Greenwood/Launching/Lily";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowsUpDownLeftRight} from "@fortawesome/free-solid-svg-icons";
import {faHouse} from "@fortawesome/free-solid-svg-icons";
import {faBed} from "@fortawesome/free-solid-svg-icons";
import {faShower} from "@fortawesome/free-solid-svg-icons";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";
import Lavenderimages from "../../../Media/Greenwood/Launching/Lavender";

const Produk1 = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const Lilywa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285338197085&text=Halo%20Tia,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Rumah%20Lily%20https://gcb-greenwoodscountrybogor.id/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const Lavenderwa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285338197085&text=Halo%20Tia,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Rumah%20Lavender%20https://gcb-greenwoodscountrybogor.id/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="container-ekaliptus">
      <div id="ekaliptus" className="container-header2">
        <h1>Cluster Ekaliptus</h1>
      </div>
      <div className="containercard2">
        <div className="card">
          <Slider {...settings}>
            {Lilyimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-judul-kartu">
            <div className="judulkartu">
              <div className="nama-rumah">Lily</div>
              <span>Subsidi DP</span>
            </div>
            <div className="cicilan">
              <div className="angka">3</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon color="#393939" icon={faArrowsUpDownLeftRight} />
            <span> : 66m²</span>
            <FontAwesomeIcon color="#393939" icon={faHouse} />
            <span> : 60m²</span>
            <FontAwesomeIcon color="#393939" icon={faBed} />
            <span>: 2</span>
            <FontAwesomeIcon color="#393939" icon={faShower} />
            <span>: 2</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Lilywa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Lavenderimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-judul-kartu">
            <div className="judulkartu">
              <div className="nama-rumah">Lavender</div>
              <span>Subsidi DP</span>
            </div>
            <div className="cicilan">
              <div className="angka">6</div>
              <div className="ket">Juta/Bulan</div>
            </div>
          </div>
          <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon color="#393939" icon={faArrowsUpDownLeftRight} />
            <span> : 88m²</span>
            <FontAwesomeIcon color="#393939" icon={faHouse} />
            <span> : 81m²</span>
            <FontAwesomeIcon color="#393939" icon={faBed} />
            <span>: 3</span>
            <FontAwesomeIcon color="#393939" icon={faShower} />
            <span>: 3</span>
          </div>
          <div className="containerwhatsapp">
            <button onClick={Lavenderwa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Produk1;
